<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "ProfessorSliderItem",
  props: {
    item:{
      type: Object,
      required: true,
    }
  },
  methods: {
    imageUrlBuilder(image){
      return new URL(this.$storeFourBaseUrl +'/filepond/profile/' + image, import.meta.url)
    },
  }
})
</script>

<template>
  <v-hover
      v-slot="{ isHovering, props }"
      open-delay="100"
  >
    <v-card
        :elevation="isHovering ? 5 : 0"
        rounded
        v-bind="props"
        class="prof-details card-v2 rounded-lg"
    >
      <router-link  :to="{name:'professor',params: {userId:item.id}}" class="" >
        <figure >
          <img  :src="imageUrlBuilder(item.profile.user_img_files.img_1)" :alt="item.name"
                contain
          />
          <figcaption class="card__caption text-center">
            <div class="card__title">{{item.name}}</div>
            <div class="card__label">دبیر درس {{item.profile.course}}</div>
          </figcaption>
        </figure>
      </router-link>
    </v-card>
  </v-hover>
</template>

<style scoped lang="scss">

</style>
